import React, {useContext, useEffect,memo} from 'react';
import styled from "styled-components";
import EasyTrade from "../../components/EasyTrade";
import CTAV3 from "../../components/CTA-v3";
import CoreFeatures from "../../components/CoreFeatures";
import Tutorials from "../../components/Tutorials";
import {useSelector} from "react-redux";
import {fetchPosts} from "../api/redux/easyx";
import gsap, {CSSPlugin} from "gsap";
import {SplitText} from "gsap/dist/SplitText";
import {wrapper} from "../api/store";
import {ApiServices} from "../api/network/ApiServices";
import {ApiParamKey} from "../api/network/ApiParamKey";
import {NextSeo} from "next-seo";
import {useRouter} from "next/router";
const EasyTradePage = ({offset,smooth, winWidth}) => {
    const getPost = useSelector((state) => state.easyxReducer);

    let page_data = getPost?.posts?.data?.page_data
    const router = useRouter();

    const easy = getPost?.posts?.data?.sections?.find(f => f?.section_data?.slug === 'easy-x-overview');
    const core = getPost?.posts?.data?.sections?.find(f => f?.section_data?.slug === 'easyx-core-features');
    const cta = getPost?.posts?.data?.sections?.find(f => f?.section_data?.slug === 'cta-easyx');
    const currentUrl = router && router.asPath;
    const tutorials = getPost?.posts?.data?.sections?.find(f => f?.section_data?.slug === 'easyx-tutoiral');


    useEffect(() => {

        let split = gsap.utils.toArray(".split-up");
        gsap.registerPlugin(SplitText, CSSPlugin);


        if(window > 767){

            gsap.utils.toArray('.split-up').forEach((item, i) => {
                const parentSplit = new SplitText(item, {
                    linesClass: "split-parent",
                    type: "lines",
                });
                const childSplit = new SplitText(item, {
                    type: "lines",
                    linesClass: "split-child"
                });

                gsap.from(parentSplit.lines, {
                    duration: 1,
                    yPercent: 150,
                    ease: 'power4.out',
                    stagger: .08,
                    scrollTrigger: {
                        trigger: item,
                        toggleActions: "restart none none reset",
                        start: "top 98%",
                    }
                });
            });

        }
    }, [getPost])

    return (
        <>
            <NextSeo
                title={`${page_data?.title ? page_data?.title + ' | Shanta Securities Limited' : 'Shanta Securities Limited' }`}
                description={page_data?.meta_description}
                canonical={"https://www.shantasecurities.com"+currentUrl}
                openGraph={{
                    type: 'website',
                    url: "https://www.shantasecurities.com"+currentUrl,
                    title: page_data?.og_title,
                    description: page_data?.og_description,
                    images: [
                        {
                            url: 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/landing-page/1688559694xs86e.webp',
                            width: 800,
                            height: 600,
                            alt: page_data?.og_title,
                        },
                        {
                            url:  'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/landing-page/1688559694xs86e.webp',
                            width: 800,
                            height: 600,
                            alt: page_data?.og_title,
                        },
                    ],
                }}
            />

            <StyledComponent>

                <div className="black">
                    <EasyTrade ex gif data={easy}/>
                    <div className="core core_features">
                        <CoreFeatures data={core}/>
                    </div>
                    {
                        tutorials &&
                        <div className="tuorital">
                            <Tutorials smooth={smooth} data={tutorials} padding={'pb-200'}/>
                        </div>

                    }
                    <CTAV3 data={cta} offset={offset} winWidth={winWidth}/>
                </div>


            </StyledComponent>
        </>
    );
};

const StyledComponent = styled.section`
    
   
    .finger-tips {
        padding-top: 200px;

        &:last-child {
            //padding-bottom: 0 !important;
        }

        @media (max-width: 767px) {
            padding-top: 120px;
    }
  }
  .finger-tips__text__bottom ul li a img {
    height: 50px !important;
  }
  .tuorital{
    .finger-tips{
        padding-top: 0;
      padding-bottom: 180px !important;

      @media(max-width: 767px){
        padding-bottom: 120px !important;
      }
    }
  }
`;



EasyTradePage.getInitialProps = wrapper.getInitialPageProps((store) => async () => {
    let api_services = ApiServices.SECTIONS;
    let param = {
        [ApiParamKey.TYPE]: 'slug',
        [ApiParamKey.VALUE]: 'shanta-easy-x',
        [ApiParamKey.GET_SECTION]: 'yes',
        [ApiParamKey.IMAGE]: 'yes',
        [ApiParamKey.POST]: 'yes',
        [ApiParamKey.GALLERY]: 'yes',
        [ApiParamKey.FILE]: 'yes',
    }
    await store.dispatch(fetchPosts([api_services, param]));
});


export default EasyTradePage;
